export const TipsDistributionRoutes = [
    {
        "url": "/tips-distribution",
        "name": "appLayout.harriSH.tips-distribution",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "tipsDistributionPageContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: []
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/tips-distribution/tips-distribution.downgrade.module");
                }
            },
        ],
    }
];
//# sourceMappingURL=tips-distribution.routes.js.map